import { createSlice } from "@reduxjs/toolkit";
import { fetchNotifications } from "./thunk/notificationsThunk";
import type { NotificationsResponseItem } from "@modules/public-comments/services/apiEndpoints";

type Status = "idle" | "loading" | "succeeded" | "failed";

interface NotificationsState {
  items: NotificationsResponseItem[];
  status: Status;
  error?: string;
}

const initialState: NotificationsState = {
  items: [],
  status: "idle",
  error: undefined
};

const notificationsSlice = createSlice({
  name: "notifications",
  initialState,
  reducers: {},
  extraReducers: builder => {
    builder
      .addCase(fetchNotifications.pending, state => {
        state.status = "loading";
        state.error = undefined;
      })
      .addCase(fetchNotifications.fulfilled, (state, action) => {
        state.status = "succeeded";
        state.items = Array.isArray(action.payload) ? action.payload : [];
      })
      .addCase(fetchNotifications.rejected, (state, action) => {
        state.status = "failed";
        state.error =
          (action.payload as string) ?? action.error.message ?? "Unknown error";
      });
  }
});

export default notificationsSlice.reducer;
